import React from 'react';
import { string } from 'prop-types';
import { ListItem } from '@thd-olt-component-react/list';

export const AdditionalResourcesLink = (props) => {
  const { url, name, contentType } = props;
  const formatContentUrl = () => `${contentType !== 'Installation Services' ? `${contentType}: ` : ''} ${name}`;
  return (
    <div id="product-overview">
      <a
        className="list__link"
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        {formatContentUrl()}
      </a>
    </div>
  );
};

AdditionalResourcesLink.displayName = 'AdditionalResourcesLink';

AdditionalResourcesLink.propTypes = {
  name: string.isRequired,
  contentType: string.isRequired,
  url: string.isRequired
};
